<template>
  <div class="page-body" style="    background: #f5f6fa;">
    <div class="top-bg-xxw01">
      <!--<div class="container"></div> -->
    </div>
    <div class="container md-2018040805-xxw">
      <div class="user-cneter-contianer">
        <div class="md-2018040806-xxw">
          <div class="md-2018040801-lty">
            <a href="#">
              <img
                class="js-headpic-xxw"
                src="../../../../static/img/head.svg"
              />
            </a>
          </div>
          <div class="top-navx-list clearfix" style="font-size: 18px;">
            <a
              class="user-nav"
              :class="item.state === 2 ? 'active' : ''"
              v-for="(item, index) in list"
              :key="index"
              @click="Cut(item, index)"
            >
              <router-link
                style="color: white"
                :style="item.state === 2 ? 'color: #4b95ff;' : ''"
                :to="item.path"
              >
                {{ item.name }}
              </router-link>
            </a>
          </div>
          <p class="user-namebox color-999">
            <span class="user-name-xxw color-333">
              {{ this.$storage.get("declareUser").userName }}
            </span>
          </p>
        </div>
        <div class="md-2018040807-xxw clearfix">
          <ul class="pull-left md2018040401-menux bgcolor-fff font-16">
            <li :class="index === 1 ? 'active' : ''" @click="switchover(1)">
              <a
                ><span class="md2018040401-lefttextx">{{ name }}</span>
              </a>
            </li>

            <li
              v-if="flag"
              :class="index === 2 ? 'active' : ''"
              @click="switchover(2)"
            >
              <a><span class="md2018040401-lefttextx">账户安全</span> </a>
            </li>
          </ul>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      index: 1,
      flag: false,
      name: "全部课程",
      list: [
        // {
        //     state: 2,
        //     name: '自购课',
        //     path: '/mySelfBuyCourse'
        // },
        {
          state: 2,
          name: "培训计划",
          path: "/trainPlanPersonal"
        },
        {
          state: 1,
          name: "我的账户",
          path: "/myAccount"
        },
        {
          state: 1,
          name: "账户设置",
          path: "/accountSet"
        }
      ]
    };
  },
  created() {
    this.$parent.leftBeginAffirm(4);

    //console.log("lalalalala================"+this.$route.params.state)

    //this.$router.push({ path: '/personalCenter' })
    //查询直播列表
    //this.loaddictWorkTypeLiveStreamingCourse();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    switchover(index) {
      if (index === 1) {
        this.index = 1;
        this.$router.push({ path: "/accountSet" });
      } else {
        this.index = 2;
        this.$router.push({ path: "/resetThePassword" });
      }
    },
    Cut(item, index) {
      this.list.forEach(element => {
        element.state = 1;
      });
      this.list[index].state = 2;

      this.name = item.name;

      if (item.name === "账户设置") {
        this.flag = true;
      } else {
        this.flag = false;
      }
    }
  }
};
</script>

<style scoped>
.jindu200610 > div span {
  position: absolute;
  top: -18px;
  color: #666;
  width: 50px;
  right: -25px;
  text-align: center;
}

.jindu200610 > div {
  position: absolute;
  height: 100%;
  border-radius: 6px;
  background: #2b83f3;
}

.jindu200610 {
  width: 400px;
  position: relative;
  border-radius: 6px;
  height: 6px;
  background-color: #ddd;
  margin-left: 30px;
}

.md20061001 .p5 {
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
}

.md-19052302-x .right .p2 {
  line-height: 30px;
}

.md20061001 .pppp .cusfont {
  margin-right: 8px;
}

.md20061001 .pppp p {
  width: 180px;
  margin-right: 20px;
}

.md20061001 .pppp1 {
  margin-top: 15px;
}

.md-19052302-x .right .p2 {
  line-height: 30px;
}

.text-overflow {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tttittt {
  width: 360px;
}

.md-19052302-x .right {
  position: relative;
  margin-left: 30px;
  height: 153px;
  width: 575px;
}

.md-19052302-x .left {
  position: initial;
  width: 272px;
  height: 153px;
  border-radius: 6px;
  overflow: hidden;
}

.md-19052302-x .left > img {
  display: block;
  width: 100%;
}

.course_img {
  position: absolute;
  top: 31%;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 19px;
  font-weight: 400;
  letter-spacing: 8px;
  padding: 0 18px;
}

.md-19052302-x .left {
  position: initial;
  width: 272px;
  height: 153px;
  border-radius: 6px;
  overflow: hidden;
}

.md-19052302-x {
  border-bottom: 1px solid #ddd;
  padding-bottom: 25px;
  margin-bottom: 25px;
  position: relative;
}

.md-19052301x .md-hd {
  color: #4994ff;
  font-weight: bold;
  line-height: 30px;
  margin-bottom: 15px;
}

.bgcolor-f6f5fa {
  background: #f6f5fa;
}

.md-19052301x {
  margin-top: 11px;
  font-size: 14px;
  border-radius: 6px;
}

.lamu-sp-421 p {
  float: left;
}

.lamu-sp-421 p {
  margin: 0 10px;
  cursor: pointer;
  position: relative;
  user-select: none;
}

.active {
  color: #4b95ff;
}

.lamu-sp-421 p.active {
  color: #3b93f6;
}

.search-my200421 .pd {
  line-height: 48px;
}

.lamu-sp-421 p {
  float: left;
}

.lamu-sp-421 p {
  margin: 0 10px;
  cursor: pointer;
  position: relative;
  user-select: none;
}

.search-my200421 .pd {
  line-height: 48px;
}

.search-my200421 .d2 {
  padding: 15px 0;
  border: 1px solid #ddd;
  margin-top: 30px;
  border-left: none;
  border-right: none;
}

.clearfix:after {
  clear: both;
  content: ".";
  display: block;
  font-size: 0;
  height: 0;
  line-height: 0;
  visibility: hidden;
}

.cusfont-search:before {
  content: "\e6e9";
}

.search-my200421 .search-btn i {
  font-size: 20px;
  vertical-align: middle;
  margin-right: 6px;
}

.search-my200421 .search-btn {
  width: 102px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  background-image: linear-gradient(to right, #63b9fd, #34dbf5);
  cursor: pointer;
}

.search-my200421 .d1 input {
  width: 690px;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
}

.search-my200421 .d1 {
  padding: 0 40px;
}

.bgcolor-f6f5fa {
  background: #f6f5fa;
}

.md-19052301x {
  margin-top: 11px;
  font-size: 14px;
  border-radius: 6px;
}

.padding-30 {
  padding: 30px;
}

.bgcolor-f6f5fa {
  background: #f6f5fa;
}

.md-2018040807-xxw .top-titx {
  line-height: 60px;
  padding: 0 28px;
  border-bottom: 1px solid #ddd;
}

.pull-right {
  float: right;
}

.md-2018040807-xxw .right-contx {
  width: 940px;
  min-height: 450px;
  padding-bottom: 34px;
  border-radius: 4px;
}

.cusfont-more:before {
  content: "\e6ed";
}

.cusfont {
  font-family: "cusfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.md2018040401-menux li .iconx {
  font-size: 12px;
}

.md2018040401-menux li.active .iconx {
  display: inline-block;
}

.md2018040401-menux .md2018040401-lefttextx {
  display: inline-block;
  width: 125px;
}

.md-2018040807-xxw .md2018040401-menux .md2018040401-lefttextx {
  width: 95px;
}

.md2018040401-menux a {
  display: inline-block;
  width: 100%;
  padding: 0 10px 0 30px;
  line-height: 60px;
  border-bottom: 1px solid #f2f2f2;
}

.md2018040401-menux li a {
  border-color: #ddd;
}

.md2018040401-menux li.active a {
  background: #4d95ff;
  color: #fff;
}

.md2018040401-menux {
  width: 200px;
  border-radius: 6px;
  overflow: hidden;
}

.pull-left {
  float: left;
}

.md-2018040807-xxw .md2018040401-menux {
  background: #f6f5fa;
  width: 168px;
  border-radius: 4px;
}

.md-2018040807-xxw {
  margin-top: 16px;
}

.color-333 {
  color: #333;
}

.md-2018040806-xxw .user-namebox .user-name-xxw {
  font-size: 14px;
  font-weight: bold;
  margin-right: 6px;
}

.color-999 {
  color: #999;
}

.md-2018040806-xxw .user-namebox {
  margin-top: 36px;
}

.md-2018040806-xxw .top-navx-list > a {
  float: left;
  line-height: 32px;
  padding: 0 8px;
  margin-right: 40px;
  color: #fff;
  font-weight: bold;
  border-radius: 16px;
}

.md-2018040806-xxw .top-navx-list > a.active {
  color: #4b95ff;
  background: #fff;
}

.font-16 {
  font-size: 16px;
}

.md-2018040806-xxw .top-navx-list {
  padding-left: 15px;
}

img {
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

.md-2018040801-lty img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

a {
  color: #333;
  text-decoration: none;
}

.md-2018040801-lty {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid #4b95ff;
}

.md-2018040806-xxw .md-2018040801-lty {
  height: 100px;
  width: 100px;
  border: 4px solid #fff;
  position: absolute;
  top: 0;
  left: 0;
}

.md-2018040806-xxw {
  padding-left: 105px;
  padding-top: 13px;
}

.md-2018040805-xxw .user-cneter-contianer {
  margin-top: -65px;
  position: relative;
}

.top-bg-xxw01 {
  height: 276px;
  box-shadow: 0 0 20px #6478f1;
  background-color: #003262;
  /* margin-top: 50px; */
}

.container {
  clear: both;
  margin: 0 auto;
  text-align: left;
  width: 1200px;
}

.md-2018040805-xxw {
  padding: 1px 30px 20px;
  background: #fff;
  margin-top: -169px;
  margin-bottom: 40px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  min-height: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/train/personalCenter/personalCenter.vue